<script setup>
import {ref, h, onMounted} from 'vue';
import {useI18n} from 'vue-i18n';
import {RMModal} from 'redmine-ui-kit';

import {useModalBus} from '@/core/composables/useModalBus';

const {closeModal} = useModalBus();

const infoData = ref(null);
const {getLocaleMessage, locale} = useI18n();
const props = defineProps({
    modalData: {
        type: Object,
        required: true,
    },
    isActive: {
        type: Boolean,
        default: () => false,
    },
});

onMounted(() => {
    const {charts} = getLocaleMessage(locale.value);
    infoData.value = JSON.parse(charts[props.modalData.chartType].info) ?? null;
});

function getChilds(childs) {
    return childs.map((item) => {
        return h(item.tag, item.attributes || {}, item.childs ? getChilds(item.childs) : item.content || '');
    });
}

function render() {
    return h(
        'div',
        {},
        getChilds(infoData.value),
    );
}
</script>

<template>
    <RMModal
        :is-active="isActive"
        transition-name="modal-fade"
        @close="closeModal(modalData.template)"
    >
        <div class="chart-info-template">
            <render v-if="infoData" />
        </div>
    </RMModal>
</template>

<style lang="scss">
.rm-modal {
    top: 25px;
}
</style>
